import { createGlobalStyle } from 'styled-components';
import { normalize } from 'styled-normalize';
import reset from 'styled-reset';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

export const CDN_API_ENDPOINT = process.env.NEXT_PUBLIC_CDN_HOST || 'https://cdn-b2c.dom.ru';

export const GlobalStyle = createGlobalStyle`
    ${reset};
    ${normalize};
  
    :root {
        --bold-h0: 56px/68px CoFoSansBold, Helvetica, sans-serif;
        --bold-h1: 40px/52px CoFoSansBold, Helvetica, sans-serif;
        --bold-h2: 32px/40px CoFoSansBold, Helvetica, sans-serif;
        --bold-h3: 24px/32px CoFoSansBold, Helvetica, sans-serif;
        --bold-h4: 20px/28px CoFoSansBold, Helvetica, sans-serif;
        --bold-h5: 16px/24px CoFoSansBold, Helvetica, sans-serif;
        --label: 12px/16px CoFoSansBold, Helvetica, sans-serif;
        --medium: 1em/1.5em CoFoSansMedium, Helvetica, sans-serif;
        --medium-s: 16px/24px CoFoSansMedium, Helvetica, sans-serif;
        --medium-xs: 14px/20px CoFoSansMedium, Helvetica, sans-serif;
        --medium-xxs: 12px/16px CoFoSansMedium, Helvetica, sans-serif;
        --regular-xxl: 24px/40px CoFoSansRegular, Helvetica, sans-serif;
        --regular-xl: 22px/36px CoFoSansRegular, Helvetica, sans-serif;
        --regular-l: 20px/32px CoFoSansRegular, Helvetica, sans-serif;
        --regular-m: 18px/28px CoFoSansRegular, Helvetica, sans-serif;
        --regular-s: 16px/24px CoFoSansRegular, Helvetica, sans-serif;
        --regular-xs: 14px/20px CoFoSansRegular, Helvetica, sans-serif;
        --regular-xxs: 12px/16px CoFoSansRegular, Helvetica, sans-serif;
    }
    
    @font-face {
        font-family: 'AeroportRegular';
        font-display: swap;
        src: url('${CDN_API_ENDPOINT}/fonts/Aeroport-regular.woff') format('woff'),
             url('${CDN_API_ENDPOINT}/fonts/Aeroport-regular.woff2') format('woff2'),
             url('${CDN_API_ENDPOINT}/fonts/Aeroport-regular.ttf') format('truetype');
        font-weight: normal;
        font-style: normal;
    }
    
    @font-face {
        font-family: 'AeroportMedium';
        font-display: swap;
        src: url('${CDN_API_ENDPOINT}/fonts/Aeroport-medium.woff') format('woff'),
             url('${CDN_API_ENDPOINT}/fonts/Aeroport-medium.woff2') format('woff2'),
             url('${CDN_API_ENDPOINT}/fonts/Aeroport-medium.ttf') format('truetype');
        font-weight: normal;
        font-style: normal;
    }
    
    @font-face {
        font-family: 'AeroportBold';
        font-display: swap;
        src: url('${CDN_API_ENDPOINT}/fonts/Aeroport-bold.woff') format('woff'),
             url('${CDN_API_ENDPOINT}/fonts/Aeroport-bold.woff2') format('woff2'),
             url('${CDN_API_ENDPOINT}/fonts/Aeroport-bold.ttf') format('truetype');
        font-weight: normal;
        font-style: normal;
    }
    
    @font-face {
        font-family: 'CoFoSansRegular';
        font-display: swap;
        src: url('${CDN_API_ENDPOINT}/fonts/CoFo_Sans-Regular.eot?#iefix') format('embedded-opentype'),
             url('${CDN_API_ENDPOINT}/fonts/CoFo_Sans-Regular.woff2') format('woff2'),
             url('${CDN_API_ENDPOINT}/fonts/CoFo_Sans-Regular.woff') format('woff'),
             url('${CDN_API_ENDPOINT}/fonts/CoFo_Sans-Regular.ttf') format('truetype');
        font-weight: normal;
        font-style: normal;
    }
    
    @font-face {
        font-family: 'CoFoSansMedium';
        font-display: swap;
        src: url('${CDN_API_ENDPOINT}/fonts/CoFo_Sans-Medium.eot?#iefix') format('embedded-opentype'),
             url('${CDN_API_ENDPOINT}/fonts/CoFo_Sans-Medium.woff2') format('woff2'),
             url('${CDN_API_ENDPOINT}/fonts/CoFo_Sans-Medium.woff') format('woff'),
             url('${CDN_API_ENDPOINT}/fonts/CoFo_Sans-Medium.ttf') format('truetype');
        font-weight: normal;
        font-style: normal;
    }
    
    @font-face {
        font-family: 'CoFoSansBold';
        font-display: swap;
        src: url('${CDN_API_ENDPOINT}/fonts/CoFo_Sans-Bold.eot?#iefix') format('embedded-opentype'),
             url('${CDN_API_ENDPOINT}/fonts/CoFo_Sans-Bold.woff2') format('woff2'),
             url('${CDN_API_ENDPOINT}/fonts/CoFo_Sans-Bold.woff') format('woff'),
             url('${CDN_API_ENDPOINT}/fonts/CoFo_Sans-Bold.ttf') format('truetype');
        font-weight: normal;
        font-style: normal;
    }

    * {
        box-sizing: border-box;
    }
    
    body {
        font-family: 'Source Sans Pro', sans-serif;
        font-size: .9375rem;
        font-weight: 400;
        line-height: 1.5;
        text-rendering: optimizeLegibility;
    }
    
    ul {
        list-style: disc;
        margin-left: 15px;
    }
    
    ol {
        list-style: decimal;
    }
    
    a {
        color: ${COLORS.Link};
        text-decoration: none;
      
        &:hover {
            text-decoration: underline;
        }
    }
`;

export const FontSourceSansPro = createGlobalStyle`
    @font-face {
        font-display: swap; 
        font-family: 'Source Sans Pro';
        font-style: normal;
        font-weight: 400;
        src: url('${CDN_API_ENDPOINT}/fonts/source-sans-pro-v21-cyrillic_cyrillic-ext_latin-regular.eot?#iefix') format('embedded-opentype'),
            url('${CDN_API_ENDPOINT}/fonts/source-sans-pro-v21-cyrillic_cyrillic-ext_latin-regular.woff2') format('woff2'),
            url('${CDN_API_ENDPOINT}/fonts/source-sans-pro-v21-cyrillic_cyrillic-ext_latin-regular.woff') format('woff'),
            url('${CDN_API_ENDPOINT}/fonts/source-sans-pro-v21-cyrillic_cyrillic-ext_latin-regular.ttf') format('truetype'),
            url('${CDN_API_ENDPOINT}/fonts/source-sans-pro-v21-cyrillic_cyrillic-ext_latin-regular.svg#SourceSansPro') format('svg');
    }

    @font-face {
        font-display: swap;
        font-family: 'Source Sans Pro';
        font-style: normal;
        font-weight: 600;
        src: url('${CDN_API_ENDPOINT}/fonts/source-sans-pro-v21-cyrillic_cyrillic-ext_latin-600.eot?#iefix') format('embedded-opentype'),
            url('${CDN_API_ENDPOINT}/fonts/source-sans-pro-v21-cyrillic_cyrillic-ext_latin-600.woff2') format('woff2'),
            url('${CDN_API_ENDPOINT}/fonts/source-sans-pro-v21-cyrillic_cyrillic-ext_latin-600.woff') format('woff'),
            url('${CDN_API_ENDPOINT}/fonts/source-sans-pro-v21-cyrillic_cyrillic-ext_latin-600.ttf') format('truetype'),
            url('${CDN_API_ENDPOINT}/fonts/source-sans-pro-v21-cyrillic_cyrillic-ext_latin-600.svg#SourceSansPro') format('svg');
    }
`;
